var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedbackStarFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    tabIndex: 0
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.788 1.103c.495-1.004 1.926-1.004 2.421 0l2.358 4.777 5.273.766c1.107.161 1.549 1.522.748 2.303l-3.816 3.719.901 5.251c.19 1.103-.968 1.944-1.959 1.423l-4.716-2.479-4.715 2.48c-.99.52-2.148-.32-1.96-1.424l.901-5.251L.41 8.949c-.801-.781-.359-2.142.748-2.303L6.43 5.88l2.358-4.777z",
    fill: "#9897DF"
  })));
}
export default SvgFeedbackStarFull;